import { useEffect } from 'react';

import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import {
    getData,
    getIsLoading,
    useDataModule,
} from '@perpay-web/data-module/useDataModule';
import { BANKS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { BankAccount } from '@perpay-web/fintech/reducers/entities/banks';

export const useLoadBankAccounts = () => {
    const { dataRequest, state } = useDataModule(() =>
        authenticatedJsonFetch(BANKS_ENDPOINT),
    );
    useEffect(() => {
        dataRequest();
    }, [dataRequest]);

    const bankAccounts: BankAccount[] = getData(state) || [];
    const isLoading = getIsLoading(state);

    return {
        bankAccounts: [...bankAccounts].sort((a, b) =>
            a.uuid.localeCompare(b.uuid),
        ),
        isLoading,
        fetchBankAccounts: dataRequest,
    };
};
